<template>
  <div>
    <h-m-styled-plaintext
      v-model="currentDisplay"
      name="display-choice"
      :nav-choices="displayOptions"
      class="mb-3"
    ></h-m-styled-plaintext>
    <svg ref="gantt"></svg>
  </div>
</template>

<script>
import Gantt from 'frappe-gantt';

export default {
  name: 'gantt',

  props: {
    tasks: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      displayOptions: [
        {text: 'Jours', link: 'Day', active: false},
        {text: 'Semaines', link: 'Week', active: false},
        {text: 'Mois', link: 'Month', active: false},
        {text: 'Quart de jours', link: 'Quarter Day', active: false},
        {text: 'Demi journées', link: 'Half Day', active: false},
      ],
      currentDisplay: 'Day',
      gantt: null,
    }
  },

  watch: {
    currentDisplay() {
      if (this.gantt) {
        this.gantt.change_view_mode(this.currentDisplay)
      }
    },
    tasks() {
      this.initGantt()
    },
  },

  methods: {
    onClick(task) {
      this.$emit('click', {task})
    },
    
    onDateChange(task, start, end) {
      this.$emit('onDateChange', {task, start, end})
    },
    
    onProgressChange(task, progress) {
      this.$emit('onProgressChange', {task, progress})
    },
    
    initGantt() {
      this.gantt = null
      this.gantt = new Gantt(this.$refs.gantt, this.tasks, {
        on_click: (task) => {
          this.onClick(task)
        },
        on_date_change: (task, start, end) => {
          this.onDateChange(task, start, end)
        },
        on_progress_change: (task, progress) => {
          this.onProgressChange(task, progress)
        },
        header_height: 50,
        column_width: 30,
        step: 24,
        view_modes: ['Quarter Day', 'Half Day', 'Day', 'Week', 'Month'],
        bar_height: 20,
        bar_corner_radius: 3,
        arrow_curve: 5,
        padding: 18,
        view_mode: this.currentDisplay,
        date_format: 'YYYY-MM-DD',
        language: 'fr',
        custom_popup_html: () => '<div></div>',
      })
    },
    
    refresh(){
      this.initGantt()
    },
  },
}
</script>

<style lang="scss">
@import "~frappe-gantt/dist/frappe-gantt.css";

.gantt .bar-progress {
  fill: $primary !important;
}

.gantt .bar-wrapper.active .bar-progress {
  fill: $primary !important;
}
</style>